import {autoRegister, resolve} from "../../../container";
import {PageScrollbar} from "../../../common/pageScrollbar";
import {PageFeatures} from "../pageFeatures";
import {EventBus, EventBusEvent} from "../../../common/eventBus";
import {DIALOG_CLOSED_EVENT, DIALOG_OPENED_EVENT, type EopDialog} from "./dialog";

@autoRegister()
export class Dialogs {

    public constructor(
        private pageScrollbar: PageScrollbar = resolve(PageScrollbar),
        private pageFeatures: PageFeatures = resolve(PageFeatures),
        eventBus: EventBus = resolve(EventBus)
    ) {
        eventBus.on(DIALOG_CLOSED_EVENT, () => this.enablePageScrollbar());
        eventBus.on(DIALOG_OPENED_EVENT, event => this.closeOtherDialogs(event));
    }

    public open(dialogId: string): void {
        const dialog = this.pageFeatures.findFirst<EopDialog>(`eop-dialog[id='${dialogId}']`);
        if (dialog) {
            dialog.showModal();
            this.pageScrollbar.disablePageScrollability();
        }
    }

    private closeOtherDialogs(event: EventBusEvent): void {
        const openingDialog = event.data as EopDialog;
        this.allDialogs()
            .filter(dialog => dialog.id !== openingDialog.id)
            .filter(dialog => dialog.isOpen())
            .forEach(dialog => dialog.close());
    }

    private enablePageScrollbar(): void {
        if (this.noOpenDialog()) {
            this.pageScrollbar.enablePageScrollability();
        }
    }

    private noOpenDialog(): boolean {
        return this.allDialogs()
            .filter(dialog => dialog.isOpen())
            .isEmpty();
    }

    private allDialogs(): EopDialog[] {
        return Array.from(this.pageFeatures.find<EopDialog>("eop-dialog"));
    }
}